import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect } from 'react'
import Chart from "react-apexcharts"
import { useTranslation } from 'react-i18next'

import Loading from '../common/Loading'

import { chartOptions as initialChartOptions } from './variablesMixChart'

import { MemberReportMixChart } from '../../../states/types/member'
import InfoTips from '../common/InfoTips'

interface MixChartProps {
  isLoading: boolean | undefined
  mixChart: MemberReportMixChart | undefined
}

const MixChart: FC<MixChartProps> = (props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    mixChart,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setChartData] = useState<any>(undefined)

  useEffect(() => {
    if (!mixChart) {
      setChartData(undefined)
      return
    }

    const chartOptions = initialChartOptions
    chartOptions.xaxis.categories = mixChart.label.days
    chartOptions.xaxis.labels.style.colors = mixChart.label.color

    setChartData({
      option: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
      },
      series: [{
        name: t('parts.mix_chart.work_hours'),
        type: 'column',
        data: mixChart.active_time,
      }, {
        name: t('parts.mix_chart.production'),
        type: 'line',
        data: mixChart.biz_point,
      }],
    })
  }, [mixChart])

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box">
        <div style={{ paddingTop: "1em", marginLeft: "0.75em", marginBottom: "0.5e", textAlign: "center" }}>
          <span style={{ fontSize: "24px", fontWeight: "bold", color: "#094E8D" }}>{t('parts.mix_chart.title')}</span>
        </div>
        <InfoTips>
          <>
            <div>
              一日ごとの操作量と作業時間の推移を表示しています
            </div>
          </>
        </InfoTips>
        {
          (isLoading || !chartData) ? (
            <Loading />
          ) : (
            <>
              <Chart
                options={chartData.option}
                type="line"
                series={chartData.series}
                height="350px"
              />
            </>
          )
        }
      </div>
    </div>
  )
}

export default MixChart
